import React from 'react';

export interface DirtyFormStateInterface {
  isDirty: boolean;
  isSubmitting: boolean;
  submit: any;
  reset: any;
  trigger?: (
    payload?: string | string[] | undefined,
    options?: { shouldFocus?: boolean | undefined }
  ) => Promise<boolean>;
}

interface DirtyForm {
  forms: Record<string, DirtyFormStateInterface>;
  setForms: React.Dispatch<React.SetStateAction<Record<string, DirtyFormStateInterface>>>;
}

const DirtyFormContext = React.createContext<DirtyForm>({
  forms: {},
  setForms: () => {},
});

export default DirtyFormContext;
